import axios from "./index";

let base = "";

class ProductApi {
  static Products = (search = null, page = 1) => {
    if (search.length) {
      return axios.get(`${base}/products`, {
        params: {
          name: search,
          page,
        },
      });
    }
    return axios.get(`${base}/products`, {
      params: {
        page,
      },
    });
  };

  static GetById = (productId) => {
    return axios.get(`${base}/products/${productId}`);
  };

  static GetByIdWithCompetitors = (productId) => {
    return axios.get(`${base}/products/${productId}/competitors`);
  };

  static Update = (productId, payload) => {
    return axios.patch(`${base}/products/${productId}`, payload);
  };

  static UploadImage = (productId, file) => {
    const formData = new FormData();
    formData.append("_method", "PATCH");
    formData.append("image", file);
    return axios.post(`${base}/products/${productId}`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  };

  static UploadPoster = (productId, file) => {
    const formData = new FormData();
    formData.append("_method", "PATCH");
    formData.append("poster", file);
    return axios.post(`${base}/products/${productId}`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  };

  static UpdateAttribute = (productId, attributeId, payload) => {
    return axios.patch(`${base}/products/${productId}/attributes/${attributeId}`, payload);
  };

  static Accounts = (product_id, params = {}) => {
    return axios.get(`${base}/products/${product_id}/accounts`, { params });
  };

  static SharedProducts = (params = {}) => {
    return axios.get(`${base}/products/shared`, { params });
  };

  static SharedAccountsByProduct = (productId, params = {}) => {
    return axios.get(`${base}/products/${productId}/accounts/shared`, { params });
  };

  static FreeZ = (z_type) => {
    return axios.get(`${base}/products/free-z`, {
      params: {
        z_type,
      },
    });
  };

  static DailyList = (date) => {
    return axios.get(`${base}/products/daily-list`, {
      params: { date },
    });
  };
}

export default ProductApi;
